module.exports = __webpack_public_path__ + "public/img/fix2.6e9dc4cf.jpg";